export default __webpack_public_path__ + "static/1876-3ddee8fb2ff8af44724a2b50f3d07af9.gif";